import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const StatsCard = ({ title, value, icon, color, onClick }) => {
  const colorClasses = {
    blue: 'bg-blue-500 text-blue-600 bg-blue-50 dark:bg-blue-900/30 dark:text-blue-400',
    green: 'bg-green-500 text-green-600 bg-green-50 dark:bg-green-900/30 dark:text-green-400',
    purple: 'bg-purple-500 text-purple-600 bg-purple-50 dark:bg-purple-900/30 dark:text-purple-400',
    red: 'bg-red-500 text-red-600 bg-red-50 dark:bg-red-900/30 dark:text-red-400',
    gray: 'bg-gray-500 text-gray-600 bg-gray-50 dark:bg-gray-700 dark:text-gray-300'
  };

  // We need to extract just the bg/text classes from the simplified map logic in the original component
  // Or just map them directly.
  
  const getIconContainerClass = (colorName) => {
    switch(colorName) {
      case 'blue': return 'bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400';
      case 'green': return 'bg-green-50 text-green-600 dark:bg-green-900/30 dark:text-green-400';
      case 'purple': return 'bg-purple-50 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400';
      case 'red': return 'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400';
      default: return 'bg-gray-50 text-gray-600 dark:bg-gray-700 dark:text-gray-400';
    }
  };

  return (
    <motion.div
      whileHover={{ scale: onClick ? 1.02 : 1 }}
      whileTap={{ scale: onClick ? 0.98 : 1 }}
      className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 ${
        onClick ? 'cursor-pointer hover:shadow-md dark:hover:shadow-gray-900' : ''
      } transition-all duration-200`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">{value}</p>
        </div>
        <div className={`p-3 rounded-lg ${getIconContainerClass(color)}`}>
          <SafeIcon icon={icon} className="h-6 w-6" />
        </div>
      </div>
    </motion.div>
  );
};

export default StatsCard;